module.exports = __webpack_public_path__ + "media/images/flags/kp-24c2b8095d90a7763af2ea5756126df0.svg";